import { Children, isValidElement, memo, ReactElement, ReactNode } from 'react'
import cn from 'classnames'
import { useIsMobile } from 'hooks/media'

interface IProps {
  children: ReactNode
  className?: string
}

const TabList = memo(function TabList({ className, children }: IProps) {
  const isMobile = useIsMobile()
  const items = Children.toArray(children).filter((child) => isValidElement(child)) as ReactElement[]

  return items.length > 1 ? (
    <div
      className={cn(
        className,
        'flex',
        'relative cursor-pointer',
        'after:absolute after:-inset-x-6 after:bottom-0 after:block after:h-px after:bg-[color:var(--colorOutlineDivider)] after:content-[""]',
        '[&>*]:mt-2.5',
        {
          'ml-4 [-webkit-tap-highlight-color:transparent] after:hidden [&>*]:mt-0': isMobile
        }
      )}
    >
      {children}
    </div>
  ) : null
})

export default TabList
